import React, {Component} from 'react';
import * as func from "../../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../../wpconfig"

class Category1st extends Component {
	constructor(props) {
		super(props);

		const r = func.deepClone(this.props.record);

		this.state = {
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record : r,
			field : this.props.type === 'dept' ? 'dept' : 'category',
		}
	}

	change = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(record.index, record, true);
		this.forceUpdate()
	}

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}
		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (this.props.record[this.props.pkKey]) {
				let record = this.props.record;
				delete record.children
				func.updateData(this.state.field + "/update", record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({record : func.deepClone(record)})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				let record = this.props.record;
				if (this.category_name.value === '') {
					this.category_name.focus();
				} else {
					delete record.category_id;
					func.updateData(this.state.field + "/insert", record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.props.showMessage('추가 되었습니다.');
							record[this.props.pkKey] = response.category_id;
							record.is_edit = EDIT_MODE.SHOW;
							this.props.onUpdate(record.index, record, true);
						} else {
							this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	onEditIndex(id) {
		if(this.state.editIndex === id)
			return;
		if(this.state.editIndex)
			this.refs["ref" + this.state.editIndex].onClose();
		else if(this.refs.ref)
			this.refs.ref.onClose();
		else if(this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex' : id
		})
	}

	onCloseDelete = (event) => {
		event.preventDefault()

		const record = this.props.record;
		if (record[this.props.pkKey]) {
			if (this.state.isEdit) {
				this.props.onUpdate(record.index, func.deepClone(this.state.record));
				this.setState({'isEdit': EDIT_MODE.SHOW});
			} else {
				if (confirm(record.category_name + '을(를) ' + MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData(this.state.field + "/delete", record).then((response) => {
						if (response.code === 'ok') {
							this.props.onRemove(record.index, this.props.depth)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(0, 1)
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
	};

	checked = () => {
		const record = this.props.record;
		if (event.target.checked) {
			record[event.target.name] = 'N';
		} else {
			record[event.target.name] = 'Y';
		}
		this.props.onUpdate(record.index, record, true);
		this.forceUpdate()
	}

	render() {
		const record = this.props.record;

		return (
			<>
				{this.state.isEdit === EDIT_MODE.SHOW ?
					<tr>
						<td onClick={() => this.props.setSelectID(record.category_id, this.props.depth, this.props.type === 'dept' ? record.category_code : '')}>
							<a className={this.props.activeId === record.category_id ? 'active' : ''}>{record.category_code}</a>
						</td>
						<td onClick={() => this.props.setSelectID(record.category_id, this.props.depth, this.props.type === 'dept' ? record.category_code : '')}><span>{record.category_name}</span></td>
						{this.props.displayYN &&
						<td>{record.disp_yn}</td>
						}
						<td>
							<div className="btn-group">
								<button className="btn btn-outline-success btn-sm" onClick={this.onEditSave}>{record[this.props.pkKey] ?'편집':'저장'}</button>
								<button className="btn btn-outline-danger btn-sm" onClick={this.onCloseDelete}>삭제</button>
							</div>
						</td>
					</tr>
					:
					<tr>
						<td colSpan={this.props.displayYN ? '4' : '3'} className="edit-row">
							<div className="row mb-2">
								<div className="col-md-4 form-group">
									<label htmlFor="category_id"><strong>카테고리 ID</strong></label>
									<label
										className="d-block">{record[this.props.pkKey] ? record[this.props.pkKey] : ''}</label>
								</div>
								<div className="col-md-8 form-group">
									<label htmlFor="category_code"><strong>카테고리 CODE</strong></label>
									<input
										type="text" name="category_code" className="form-control"
										value={record.category_code}
										readOnly={record[this.props.pkKey]}
										onChange={this.change}/>
								</div>
							</div>
							<div className="row mb-2">
								<div className="col-md-12 form-group">
									<label htmlFor="category_name"><strong>카테고리 이름</strong></label>
									<input
										type="text" name="category_name" className="form-control"
										value={record.category_name || ''}
										ref={(ref) => this.category_name = ref}
										onChange={this.change}/>
								</div>
							</div>
							<div className="row mb-2">
								<div className="col-md-12 form-group">
									<label htmlFor="category_name_en"><strong>카테고리 영문</strong></label>
									<input
										type="text" name="category_name_en" className="form-control"
										value={record.category_name_en || ''}
										ref={(ref) => this.category_name_en = ref}
										onChange={this.change}/>
								</div>
							</div>
							<div className="row mb-2">
								<div className="col-md-12 form-group">
									<label htmlFor="category_name_abbr"><strong>카테고리 영문약어</strong></label>
									<input
										type="text" name="category_name_abbr" className="form-control"
										value={record.category_name_abbr || ''}
										ref={(ref) => this.category_name_abbr = ref}
										onChange={this.change}/>
								</div>
							</div>
							<div className="row mb-2">
								<div className="col-md-3 form-group">
									<label htmlFor="visible_seq"><strong>순서</strong></label>
									<input type="text" name="visible_seq" className="form-control"
										   value={record.visible_seq || ''}
										   onChange={this.change}/>
								</div>
								<div className="col-md-5 form-group">
									<label htmlFor="visible_seq"><strong>TOP 연구자 통계 산정 기간</strong></label>
									<input type="text" name="topresearcher_stats_year" className="form-control"
										   value={record.topresearcher_stats_year || ''}
										   onChange={this.change}/>
								</div>
								{this.props.displayYN &&
									<div className="col-md-3 form-group">
										<label htmlFor=""><strong>출력여부</strong></label>
										<div className="mt-1">
											<div className="form-check form-check-inline">
												<input className="form-check-input" type="checkbox" name="disp_yn"
													   id={"disp_yn" + record.category_code}
													   checked={record.disp_yn !== 'Y'}
													   onChange={this.checked}/>
												<label className="form-check-label"
													   htmlFor={"disp_yn" + record.category_code}>출력안함</label>
											</div>
										</div>
									</div>
								}

							</div>
							{this.state.field === 'dept' &&
								<>
									<div className="row mb-2">
										<div className="col-md-12 form-group">
											<label htmlFor="homepage"><strong>Home Page</strong></label>
											<input
												type="text" name="homepage" className="form-control"
												value={record.homepage || ''}
												ref={(ref) => this.homepage = ref}
												onChange={this.change}/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-md-12 form-group">
											<label htmlFor="address"><strong>주소</strong></label>
											<input
												type="text" name="address" className="form-control"
												value={record.address || ''}
												ref={(ref) => this.address = ref}
												onChange={this.change}/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-md-12 form-group">
											<label htmlFor="tel"><strong>전화번호</strong></label>
											<input
												type="text" name="tel" className="form-control" value={record.tel || ''}
												ref={(ref) => this.tel = ref}
												onChange={this.change}/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-md-12 form-group">
											<label htmlFor="gps"><strong>GPS</strong></label>
											<input
												type="text" name="gps" className="form-control" value={record.gps || ''}
												ref={(ref) => this.gps = ref}
												onChange={this.change}/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-md-12 form-group">
											<label htmlFor="thumbnail"><strong>썸네일</strong></label>
											<input
												type="text" name="thumbnail" className="form-control"
												value={record.thumbnail || ''}
												ref={(ref) => this.thumbnail = ref}
												onChange={this.change}/>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-md-12 form-group">
											<label htmlFor="head_name"><strong>학과장</strong></label>
											<input
												type="text" name="head_name" className="form-control"
												value={record.head_name || ''}
												ref={(ref) => this.head_name = ref}
												onChange={this.change}/>
										</div>
									</div>
								</>
							}
							<div className="btn-group float-right">
								{record[this.props.pkKey] ?
									<button className="btn btn-outline-primary btn-sm"
											onClick={this.onEditSave}>수정</button>
									:
									<button className="btn btn-outline-primary btn-sm"
											onClick={this.onEditSave}>저장</button>
								}
								<button className="btn btn-outline-secondary btn-sm" onClick={this.onCloseDelete}>닫기
								</button>
							</div>
						</td>
					</tr>
				}
			</>
		)
	}
}

export default Category1st;